import burgeonConfig from '../../../assets/config';

export default `${burgeonConfig.prefixCls}date-picker-cells`;



// WEBPACK FOOTER //
// ./src/components/date-picker/base/prefixCls.js